import { render, staticRenderFns } from "./EcommerceEarningsChart.vue?vue&type=template&id=0135c4ec&"
import script from "./EcommerceEarningsChart.vue?vue&type=script&lang=js&"
export * from "./EcommerceEarningsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports